import React from "react";
import { GetServerSideProps } from "next";

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }

  return {
    redirect: {
      permanent: true,
      destination: `/preview/blog#category=newsroom`,
    },
  };
};

const News = ({}) => {
  return <div id="root"></div>;
};

export default News;
